import type { ControlMode } from '@/shared/types/core'
import type { ControlModeFactory, ControlModeRegistry } from '@/shared/types/services'
import type { NativeControlServices } from './NativeControlUtils'

interface ControlModeRegistryHooks {
  registerFactory: (mode: ControlMode, factory: ControlModeFactory<NativeControlServices>) => void
  unregisterFactory: (mode: ControlMode) => boolean
  has: (mode: ControlMode) => boolean
  listModes: () => ControlMode[]
}

/** 运行时 control mode 工厂注册表实现。 */
export class ControlModeRegistryImpl implements ControlModeRegistry {
  constructor(private readonly hooks: ControlModeRegistryHooks) {}

  registerFactory<TServices = unknown>(
    mode: ControlMode,
    factory: ControlModeFactory<TServices>
  ): void {
    this.hooks.registerFactory(mode, factory as ControlModeFactory<NativeControlServices>)
  }

  unregisterFactory(mode: ControlMode): boolean {
    return this.hooks.unregisterFactory(mode)
  }

  has(mode: ControlMode): boolean {
    return this.hooks.has(mode)
  }

  listModes(): ControlMode[] {
    return this.hooks.listModes()
  }

  dispose(): void {}
}
